import imageOne from '@/assets/images/cities/vaughan1.jpg'
import imageTwo from '@/assets/images/cities/vaughan2.jpg'
import imageThree from '@/assets/images/cities/vaughan3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Vaughan',
  writeup: '',
  website: 'MyVaughanNotaryPublic.com',
  url: 'https://www.myvaughannotarypublic.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '(647) 795-2772',
      hours: {
        monday: '9:00AM to 6:00PM',
        tuesday: '9:00AM to 6:00PM',
        wednesday: '9:00AM to 6:00PM',
        thursday: '9:00AM to 6:00PM',
        friday: '9:00AM to 6:00PM',
        saturday: '',
        sunday: ''
      },
      address: 'Steeles Avenue West Location',
      notes: ''
    },
    {
      name: '',
      open: true,
      phone: '(647) 795-2772',
      hours: {
        monday: '12:00PM to 5:00PM',
        tuesday: '12:00PM to 5:00PM',
        wednesday: '12:00PM to 5:00PM',
        thursday: '12:00PM to 5:00PM',
        friday: '12:00PM to 5:00PM',
        saturday: '',
        sunday: ''
      },
      address: 'Islington Ave Location',
      notes: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/ontarioGTA/cities/vaughan.js